<template>
  <div className="animated">
    <i class="icon-menu mr-1"></i>Applicants<hr />
      <v-server-table 
        class="bg-light p-2 vue-table-table"
        name="dataTableApplicantList"
        :columns="columns"
        :url="url"
        :options="options"
        :useVuex="true"
        :theme="theme"
        id="table-applicants"
        :preserveState="preserveState"
      >
        <template slot="fullName" slot-scope="props">
          {{ props.row.fullName }}
        </template>
        <template slot="datetimeSubmitted" slot-scope="props">
          {{ $moment(props.row.datetimeSubmitted).format('MM/DD/YY h:mma') }}
        </template>
        <template slot="user" slot-scope="props">
          {{ props.row.user?"Yes":"No" }}
        </template>
        <template slot="child_row" slot-scope="props">
          <div class="app-data-item"><b>Experience:</b> {{props.row.data.experience || "N/A"}}
            <div v-if="props.row.data.experience === 'yes'">
             - <b>Years:</b> {{props.row.data.experienceYears}}<br />
             - <b>Details:</b> {{props.row.data.experienceDetails}}
            </div>
          </div>
          <div class="app-data-item"><b>Child Playing:</b> {{props.row.data.childPlaying || "N/A"}}
            <div v-if="props.row.data.childPlaying === 'yes'">
             - <b>Child's Name:</b> {{props.row.data.childName}}<br />
             - <b>Child's Age:</b> {{props.row.data.childAge}}
            </div>
          </div>
          <div class="app-data-item"><b>Agrees to Terms:</b> {{props.row.data.agreesToTerms ? "Yes" : "No"}}</div>
          <div class="app-data-item"><b>Shirt Size:</b> {{props.row.data.shirtSize || "-"}}</div>
        </template>
      </v-server-table>
  </div>
</template>

<script>
// {"sport":"Flag Football, T-Ball, Field Hockey, Cricket","type":"open","experience":"yes","experienceYears":"7","experienceDetails":"I did the thing at the place with the people and stuff","childPlaying":"yes","childName":"Lenny Lovenstein","childAge":"11","agreesToTerms":true}
import Vue from 'vue'
import { HTTP } from '@/services/http-common'
import { constants } from '@/shared/constants'
import { ServerTable, Event } from 'vue-tables-2-premium'
import { mapGetters, mapActions } from 'vuex'

Vue.use(ServerTable)

export default {
  name: 'ApplicantList',
  components: {
    Event
  },
  props: {
    userRole: {
      type: String,
      default: null
    }
  },
  data: function () {
    return {
      columns: ['fullName', 'datetimeSubmitted', 'user', 'phone', 'email', 'data.sport', 'data.type'],
      options: {
        perPage: 30,
        perPageValues: [30,60,90],
        requestFunction (data) {
          return HTTP.get(this.url, {
              params: data
          }).catch(function (e) {
              this.dispatch('error', e)
          }.bind(this))
        },
        requestAdapter (data) {
          let query = {
            sort: data.orderBy ? data.orderBy : 'datetimeSubmitted',
            direction: data.ascending ? 'asc' : 'desc',
            itemsPerPage: data.limit ? data.limit : constants.LIST_DEFAULT_ITEMS_PER_PAGE,
            page: data.page ? data.page : '1'
          }
          if (data.query !='') {
            query.search_filter = data.query
          }
          if (data.orderBy) {
            let param = 'order[' + data.orderBy + ']'
            query[param] = data.ascending ? 'asc' : 'desc'
          } else {
            query['order[datetimeSubmitted]'] = 'desc'
          }
          return query
        },
        responseAdapter ({data}) {
          return {
            data: data['hydra:member'],
            count: data['hydra:totalItems']
          }
        },
        headings: {
          fullName: 'Name',
          user: 'Member',
          datetimeSubmitted: 'Date',
          'data.type': 'Type',
          'data.sport': 'Sport',
          actions: 'Actions'
        },
        sortable: ['id', 'fullName', 'datetimeSubmitted'],
        filterable: ['id', 'fullName', 'data'],
        sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
        pagination: {
          chunk: 5,
          edge: false,
          nav: 'scroll'
        }
      },
      preserveState: true,
      useVuex: true,
      theme: 'bootstrap4',
      template: 'default',
      viewUid: null
    }
  },
  computed: {
    ...mapGetters([
      // 'applicants',
      'business'
    ]),
    url () {
      return this.currentBusiness.id ? '/applicants?business=' + this.currentBusiness.id : '/applicants'
    },
    // async applicantdata () {
    //   let applicants = []
    //   await HTTP.get(this.url, {
    //       params: this.options.requestAdapter({})
    //   }).then(resp => {
    //     applicants = resp.data["hydra:member"]
    //   })
    //   return applicants
    // }
  },
  methods: {
    ...mapActions([
      'getApplicants'
    ]),
    doGetApplicants(){
      let params = {}
      if (this.currentBusiness.id !== null) {
        params.business = this.currentBusiness.id
      }
      this.getApplicants(params)
    }
  },
  filters: {
    formatRole: function (value) {
      if (!value) return ''
      value = value.substring(4).toLowerCase()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  }
};
</script>

<style scoped>
.app-data-item div b {
  color: var(--cyan);
}
</style>